<!-- Home.veu -->
<template>
  <div class="w-full">
    <panel title="E-book" noButton="true">
      <BooksList class="" />
    </panel>

    <panel title="PBT Di Seluruh Malaysia" noButton="true">
      <malaysiaMap class="w-full h-full" />
    </panel>

    <panel title="PBTPay" noButton="true">
      <div
        class="d-flex row row-space-10 m-b-10 justify-content-around align-content-stretch"
      >
        <!-- begin col-4 -->
        <div
          class="col-md-auto col-10 flex-grow-1 transition duration-500 ease-in-out transform hover:scale-105"
        >
          <div class="widget widget-stats bg-gradient-teal m-b-10">
            <div class="stats-icon stats-icon-lg">
              <i class="fa fa-list-ol fa-fw"></i>
            </div>
            <div class="stats-content">
              <div class="stats-title">Jumlah PBT</div>
              <div class="stats-number">
                101
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <!-- <div class="stats-progress progress">
                <div class="progress-bar" style="width: 70.1%"></div>
              </div> -->
              <div class="stats-desc"></div>
            </div>
          </div>
        </div>
        <!-- end col-4 -->
        <!-- begin col-4 -->
        <div
          class="col-md-auto col-10 flex-grow-1 transition duration-500 ease-in-out transform hover:scale-105"
        >
          <div class="widget widget-stats bg-gradient-blue m-b-10">
            <div class="stats-icon stats-icon-lg">
              <i class="fa fa-dollar-sign fa-fw"></i>
            </div>
            <div class="stats-content">
              <div class="stats-title">Kutipan 2022 (RM)</div>
              <div class="stats-number">RM176.6M</div>
              <!-- <div class="stats-progress progress">
                <div class="progress-bar" style="width: 40.5%"></div>
              </div> -->
              <div class="stats-desc"></div>
            </div>
          </div>
        </div>
        <!-- end col-4 -->
        <!-- begin col-4 -->
        <div
          class="col-md-auto col-10 flex-grow-1 transition duration-500 ease-in-out transform hover:scale-105"
        >
          <div class="widget widget-stats bg-gradient-purple m-b-10">
            <div class="stats-icon stats-icon-lg">
              <i class="fa fa-dollar-sign fa-fw"></i>
            </div>
            <div class="stats-content">
              <div class="stats-title">Kutipan 2023 (RM)</div>
              <div class="stats-number">RM334.0M</div>
              <!-- <div class="stats-progress progress">
                <div class="progress-bar" style="width: 76.3%"></div>
              </div> -->
              <div class="stats-desc"></div>
            </div>
          </div>
        </div>
        <!-- end col-4 -->
        <!-- begin col-4 -->
        <div
          class="col-md-auto col-10 flex-grow-1 transition duration-500 ease-in-out transform hover:scale-105"
        >
          <div class="widget widget-stats bg-gradient-black m-b-10">
            <div class="stats-icon stats-icon-lg">
              <i class="fa fa-dollar-sign fa-fw"></i>
            </div>
            <div class="stats-content">
              <div class="stats-title">Kutipan 2024 (RM)</div>
              <div class="stats-number">RM178.0M</div>
              <!-- <div class="stats-progress progress">
                <div class="progress-bar" style="width: 54.9%"></div>
              </div> -->
              <div class="stats-desc"></div>
            </div>
          </div>
        </div>
        <!-- end col-4 -->
        <!-- begin col-4 -->
        <div
          class="col-md-auto col-10 flex-grow-1 transition duration-500 ease-in-out transform hover:scale-105"
        >
          <div class="widget widget-stats bg-gradient-orange m-b-10">
            <div class="stats-icon stats-icon-lg">
              <i class="fa fa-user fa-fw"></i>
            </div>
            <div class="stats-content">
              <div class="stats-title">Pengguna</div>
              <div class="stats-number">8,004,221</div>
              <!-- <div class="stats-progress progress">
                <div class="progress-bar" style="width: 23.5%"></div>
              </div> -->
              <div class="stats-desc"></div>
            </div>
          </div>
        </div>
        <!-- end col-4 -->
      </div>
    </panel>
    <!-- Table  -->
    <panel title="Status Transaksi PBTPay" noButton="true">
      <!-- begin table-responsive -->
      <div class="table-responsive">
        <table class="table table-striped m-b-0">
          <!-- <thead>
            <tr>
              <th>Jumlah Kutipan</th>
              <th>Email Address</th>
            </tr>
          </thead> -->
          <tbody>
            <tr>
              <td>Jumlah Kutipan</td>
              <td>RM753.6M</td>
            </tr>
            <tr>
              <td>Jumlah Transaksi</td>
              <td>959,897</td>
            </tr>
            <tr>
              <td>Jumlah Pengguna</td>
              <td>8,004,221</td>
            </tr>
            <tr>
              <td>Jumlah Pengguna Berdaftar</td>
              <td>512,855</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- end table-responsive -->
    </panel>

    <panel id="osc" title="OSC 3.0 Plus Online" noButton="true">
      <!-- date picker range  -->
      <div class="form-group row">
        <!-- <label class="col-md-1 col-form-label text-center">Tarikh</label> -->
        <datePickerRange class="mx-3" />
        <button type="button" class="btn btn-primary col-1 mx-5">Saring</button>
      </div>
      <p class="my-5 text-xl font-semibold">
        Jumlah Permohonan Mengikut Kategori
      </p>
      <div class="mx-auto mt-5" style="width: 900px">
        <!-- <polarAreaChar /> -->
        <donutChart class="col" />
      </div>
      <p class="my-5 text-xl font-semibold">Tempoh Piagam Permohonan</p>
      <div>
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :lineNumbers="true"
          :search-options="{ enabled: true, placeholder: 'Search this table' }"
          :pagination-options="{ enabled: true, position: 'bottom' }"
          :selectOptions="{
            enabled: false,
            selectOnCheckboxOnly: true,
            selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
          }"
        >
          <div slot="selected-row-actions" style="margin: -2px 0">
            <button class="btn btn-xs btn-primary m-r-5">Action 1</button>
            <button class="btn btn-xs btn-grey">Action 2</button>
          </div>
        </vue-good-table>
      </div>
    </panel>
    <panel id="iTegur" title="i-Tegur" noButton="true">
      <div class="row">
        <section
          class="col-sm-12 col-md-9 p-0 h-full transition duration-500 ease-in-out transform hover:scale-105"
        >
          <p class="ml-4 mt-4 text-xl font-semibold">Jumlah Aduan Tahunan</p>

          <div class="mt-20">
            <vn-bar
              :model="barChart.data"
              textField="label"
              valueField="value"
              :staggerLabels="barChart.staggerLabels"
              x-format=",.1f"
              y-format=",.2f"
            >
            </vn-bar>
          </div>
        </section>
        <section class="col-sm-12 col-md-3 sm:mt-5 md:mt-0 p-4">
          <div
            class="transition duration-500 ease-in-out transform hover:scale-105"
          >
            <div class="widget widget-stats bg-gradient-teal m-b-10">
              <div class="stats-content">
                <div class="stats-title">Jumlah Keseluruhan Aduan</div>
                <div class="stats-number">
                  38623
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="stats-desc"></div>
              </div>
            </div>
          </div>
          <!-- end col-4 -->
          <!-- begin col-4 -->
          <div
            class="transition duration-500 ease-in-out transform hover:scale-105"
          >
            <div class="widget widget-stats bg-gradient-blue m-b-10">
              <div class="stats-content">
                <div class="stats-title">Jumlah Aduan Baharu</div>
                <div class="stats-number">1765</div>
              </div>
            </div>
          </div>
          <!-- end col-4 -->
          <!-- begin col-4 -->
          <div
            class="transition duration-500 ease-in-out transform hover:scale-105"
          >
            <div class="widget widget-stats bg-gradient-purple m-b-10">
              <div class="stats-content">
                <div class="stats-title">Jumlah Aduan Dalam Tindakan</div>
                <div class="stats-number">1034</div>
              </div>
            </div>
          </div>
          <!-- end col-4 -->
          <!-- begin col-4 -->
          <div
            class="transition duration-500 ease-in-out transform hover:scale-105"
          >
            <div class="widget widget-stats bg-gradient-black m-b-10">
              <div class="stats-content">
                <div class="stats-title">Jumlah Aduan Telah Selesai</div>
                <div class="stats-number">34387</div>

                <div class="stats-desc"></div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="">
        <p class="my-5 text-center text-xl font-semibold">
          Statistics of Total Complaints by Category
        </p>
        <div class="mx-auto" style="width: 1200px">
          <donutChart2 class="col-sm-12 col-md-7 my-8" />
        </div>
      </div>
    </panel>
    <!-- =========================================Ahli Majlis PBT================================================== -->
    <panel id="AhliMajlisPBT" title="Ahli Majlis PBT" noButton="true">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <!-- lelaki div  -->
          <div class="d-flex bg-blue-500 text-left p-5">
            <div class="text-start mx-5">
              <svg
                width="52px"
                height="52px"
                viewBox="0 0 48 48"
                version="1"
                xmlns="http://www.w3.org/2000/svg"
                enable-background="new 0 0 48 48"
              >
                <polygon
                  fill="#FF9800"
                  points="24,37 19,31 19,25 29,25 29,31"
                ></polygon>
                <g fill="#FFA726">
                  <circle cx="33" cy="19" r="2"></circle>
                  <circle cx="15" cy="19" r="2"></circle>
                </g>
                <path
                  fill="#FFB74D"
                  d="M33,13c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,5,4,9,9,9s9-4,9-9C33,18.9,33,14.1,33,13z"
                ></path>
                <path
                  fill="#424242"
                  d="M24,4c-6.1,0-10,4.9-10,11c0,0.8,0,2.3,0,2.3l2,1.7v-5l12-4l4,4v5l2-1.7c0,0,0-1.5,0-2.3c0-4-1-8-6-9l-1-2 H24z"
                ></path>
                <g fill="#784719">
                  <circle cx="28" cy="19" r="1"></circle>
                  <circle cx="20" cy="19" r="1"></circle>
                </g>
                <polygon fill="#fff" points="24,43 19,31 24,32 29,31"></polygon>
                <polygon
                  fill="#D32F2F"
                  points="23,35 22.3,39.5 24,43.5 25.7,39.5 25,35 26,34 24,32 22,34"
                ></polygon>
                <path
                  fill="#546E7A"
                  d="M29,31L29,31l-5,12l-5-12c0,0-11,2-11,13h32C40,33,29,31,29,31z"
                ></path>
              </svg>
              <p class="ml-2 text-gray-700 m-0 text-center font-bold">Lelaki</p>
            </div>
            <div class="d-flex align-content-center px-5 text-2xl">
              <p class="align-content-center text-xl font-semibold">1,439</p>
              <span class="mx-2 align-content-center">Orang</span>
            </div>
          </div>
          <!-- Wanita div  -->
          <div class="d-flex wanitaColor text-left sm:mt-2 md:mt-6 p-5">
            <div class="text-start mx-5">
              <svg
                width="52px"
                height="52px"
                viewBox="0 0 48 48"
                version="1"
                xmlns="http://www.w3.org/2000/svg"
                enable-background="new 0 0 48 48"
              >
                <rect
                  x="16"
                  y="15"
                  fill="#BF360C"
                  width="16"
                  height="18"
                ></rect>
                <path
                  fill="#78909C"
                  d="M40,44H8c0-11,11-13,11-13h10C29,31,40,33,40,44z"
                ></path>
                <path
                  fill="#FF9800"
                  d="M24,37c-2.2,0-5-6-5-6v-6h10v6C29,31,26.2,37,24,37z"
                ></path>
                <path
                  fill="#FFB74D"
                  d="M33,14c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,5,4,9,9,9s9-4,9-9C33,19.9,33,15.1,33,14z"
                ></path>
                <path
                  fill="#FF5722"
                  d="M24,4C17.9,4,9,7.4,9,27.3l7,4.7V19l12-7l4,5v15l7-6c0-4-0.7-20-11-20l-1-2H24z"
                ></path>
                <path
                  fill="#FFB74D"
                  d="M24,38c-4.4,0-5-7-5-7s2.5,4,5,4s5-4,5-4S28.4,38,24,38z"
                ></path>
                <circle fill="#784719" cx="28" cy="21" r="1"></circle>
                <circle fill="#784719" cx="20" cy="21" r="1"></circle>
              </svg>
              <p class="ml-2 text-gray-700 m-0 text-center font-bold">Wanita</p>
            </div>
            <div class="d-flex align-content-center px-5 text-2xl">
              <p class="align-content-center text-xl font-semibold">1,439</p>
              <span class="mx-2 align-content-center">Orang</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="sm:mt-8 md:mt-0">
            <pieChart2 class="" style="width: 530px" />
          </div>
        </div>
      </div>

      <div class="row">
        <p
          class="col-sm-12 col-md-6 my-5 align-self-start text-xl font-semibold"
        >
          Bilangan Ahli Majlis PBT Mengikut Negeri dan Jantina
        </p>
        <p
          class="col-sm-12 col-md-6 my-5 align-self-start text-xl font-semibold"
        >
          Peratusan Ahli Majlis PBT Wanita Berbanding Lelaki
        </p>
      </div>
      <div class="row h-100">
        <!-- First Column: -->
        <section class="col-sm-12 col-md-6 d-flex flex-column">
          <barChartOne class="" />
        </section>

        <!-- Second Column: -->
        <section class="col-sm-12 col-md-6 d-flex flex-column">
          <barChartTwo class="" />
        </section>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6">
          <p class="my-5 text-xl font-semibold">
            Bilangan Ahli Majlis Mengikut Status OKU
          </p>
          <div class="w-full h-96">
            <barChartThree class="border" />
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <p class="my-5 text-xl font-semibold">
            Bilangan Ahli Majlis PBT Mengikut Umur
          </p>
          <div class="w-full h-96">
            <barChartFour class="border" />
          </div>
        </div>
      </div>
    </panel>
    <panel id="PasarPBT" title="Pasar PBT" noButton="true">
      <p class="py-3 sm:text-center md:text-left text-xl font-semibold">
        Bilangan Lokasi & Lesen
      </p>
      <div
        class="d-flex row row-space-10 m-b-10 justify-content-around align-content-stretch"
      >
        <!-- begin col-1 -->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-gradient-red m-b-10">
            <div class="stats-content">
              <div class="stats-title">Pasar Malam</div>
              <div class="font-bold text-lg">106 Lokasi</div>
              <div class="font-bold text-lg">3,951 Lesen</div>
            </div>
          </div>
        </div>
        <!-- end col-1 -->
        <!-- begin col-2 -->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-gradient-blue m-b-10">
            <div class="stats-content">
              <div class="stats-title">Pasar Pagi</div>
              <div class="font-bold text-lg">32 Lokasi</div>
              <div class="font-bold text-lg">855 Lesen</div>
            </div>
          </div>
        </div>
        <!-- end col-2 -->
        <!-- begin col-3 -->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-gradient-purple m-b-10">
            <div class="stats-content">
              <div class="stats-title">Pasar Tani</div>
              <div class="font-bold text-lg">16 Lokasi</div>
              <div class="font-bold text-lg">501 Lesen</div>
            </div>
          </div>
        </div>
        <!-- end col-3 -->
        <!-- begin col-4 -->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-gradient-black m-b-10">
            <div class="stats-content">
              <div class="stats-title">Pasar Minggu</div>
              <div class="font-bold text-lg">8 Lokasi</div>
              <div class="font-bold text-lg">318 Lesen</div>
            </div>
          </div>
        </div>
        <!-- end col-4 -->
        <!-- begin col-5 -->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-gradient-orange m-b-10">
            <div class="stats-content">
              <div class="stats-title">Pasar Tamu</div>
              <div class="font-bold text-lg">4 Lokasi</div>
              <div class="font-bold text-lg">218 Lesen</div>
            </div>
          </div>
        </div>
        <!-- end col-5 -->
        <!-- begin col-6 -->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-gradient-teal m-b-10">
            <div class="stats-content">
              <div class="stats-title">Jumlah</div>
              <div class="font-bold text-lg">166 Lokasi</div>
              <div class="font-bold text-lg">5,843 Lesen</div>
            </div>
          </div>
        </div>

        <!-- end col-6 -->
      </div>
      <div class="row">
        <div class="col">
          <p class="my-5 text-xl font-semibold">
            Peratus Jenis Pasar Di Malaysia 2024
          </p>
          <div class=""><pieEchartOne /></div>
        </div>
        <div class="col">
          <p class="my-5 text-xl font-semibold">
            Bilangan Lokasi Mengikut Jenis Pasar Di PBT Malaysia 2024
          </p>
          <div class="pb-4 pt-2"><barchartTwo /></div>
        </div>
      </div>
      <div class="row">
        <p
          class="col-sm-12 col-md-6 my-5 align-self-start text-xl font-semibold"
        >
          Bilangan Lokasi Pasar Malam Mengikut Negeri 2024
        </p>
        <p
          class="col-sm-12 col-md-6 my-5 align-self-start text-xl font-semibold"
        >
          Peratus Pengeluaran Lesen Pasar Di Malaysia 2024
        </p>
      </div>
      <div class="row h-100">
        <!-- First Column: -->
        <section class="col-sm-12 col-md-6 d-flex flex-column">
          <barchartThree class="" />
        </section>

        <!-- Second Column: -->
        <section class="col-sm-12 col-md-6 d-flex flex-column">
          <piechartFour class="" />
        </section>
      </div>
    </panel>
    <panel
      id="cctv"
      title="Taburan Pemasangan CCTV di Seluruh Malaysia"
      noButton="true"
    >
      <cctvMap class="w-full h-full" />
    </panel>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
//books
import BooksList from "../Books/BooksList.vue";

import datePickerRange from "../../components/jkt/uiElement/datePickerRange.vue";
// import { alertMixin } from "../mixin/abdullahMixin";
import { useAbdullahStore } from "../../store/abdullahStore";
//mapAction always in the methods while mapState always in computed
import { mapState, mapActions } from "pinia";
import malaysiaMap from "./Map.vue";
import cctvMap from "./MapCctv.vue";
// charts
import polarAreaChar from "../charts/polarAreaChart.vue";
import donutChart from "../charts/donutChart.vue";
import donutChart2 from "../charts/donutChart2.vue";
import pieChart2 from "../charts/pieChart2.vue";
//ahliMajlis charts
import barChartOne from "../charts/ahliMajlisPBT/barChartOne.vue";
import barChartTwo from "../charts/ahliMajlisPBT/barChartTwo.vue";
import barChartThree from "../charts/ahliMajlisPBT/barChartThree.vue";
import barChartFour from "../charts/ahliMajlisPBT/barChartFour.vue";
// pasar charts
import pieEchartOne from "../charts/pasarPBT/pieEchartOne.vue";
import barchartTwo from "../charts/pasarPBT/barchartTwo.vue";
import barchartThree from "../charts/pasarPBT/barChartThree.vue";
import piechartFour from "../charts/pasarPBT/pieEchartFour.vue";
export default {
  components: {
    BooksList,
    malaysiaMap,
    VueApexCharts,
    polarAreaChar,
    donutChart,
    donutChart2,
    datePickerRange,
    pieChart2,
    pieEchartOne,
    barchartTwo,
    barChartOne,
    barChartTwo,
    barChartThree,
    barChartFour,
    barchartThree,
    piechartFour,
    cctvMap,
  },
  // mixins: [alertMixin],
  data() {
    var barChartData = [
      {
        key: "Cumulative Return",
        values: [
          { label: "2017", value: 29, color: "#ff5b57" },
          { label: "2018", value: 15, color: "#f59c1a" },
          { label: "2019", value: 32, color: "#00ACAC" },
          { label: "2020", value: 196, color: "#5AC8FA" },
          { label: "2021", value: 44, color: "#348fe2" },
          { label: "2022", value: 98, color: "#727cb6" },
          { label: "2023", value: 13, color: "#b6c2c9" },
          { label: "2024", value: 5, color: "#2d353c" },
        ],
      },
    ];
    var pieChartData = [
      { label: "Kebenaran Merancang", value: 706, color: "#a83232" },
      {
        label: "Kebenaran Merancang (Menara atau Struktur Komunikasi)",
        value: 8,
        color: "#32a852",
      },
      {
        label: "Kebenaran Merancang bagi Industrial Green Lane (IGL)",
        value: 4,
        color: "#3275a8",
      },
      { label: "Pelan Bangunan", value: 759, color: "#a8327b" },
      {
        label: "Pelan Bangunan (Menara atau Struktur Komunikasi)",
        value: 6,
        color: "#32a8a1",
      },
      {
        label: "Pelan Bangunan bagi Industrial Green Lane (IGL)",
        value: 4,
        color: "#a89b32",
      },
      {
        label: "Pelan Bangunan bagi Self Regulation (SR)",
        value: 3,
        color: "#8a32a8",
      },
      { label: "Pelan Jalan Dan Perparitan", value: 148, color: "#a87532" },
      {
        label: "Pelan Jalan Dan Perparitan bagi Industrial Green Lane (IGL)",
        value: 2,
        color: "#8a8a32",
      },
      { label: "Pelan Kerja Tanah", value: 136, color: "#3265a8" },
      {
        label: "Pelan Kerja Tanah bagi Industrial Green Lane (IGL)",
        value: 3,
        color: "#a83265",
      },
      { label: "Pelan Lampu Jalan", value: 86, color: "#32a87a" },
      { label: "Pelan Landskap", value: 128, color: "#7a32a8" },
      {
        label: "Penamaan Taman/Jalan/Bangunan (TJB)",
        value: 74,
        color: "#a832a8",
      },
      { label: "Permit Pembinaan Kecil bagi EVCB", value: 2, color: "#a85a32" },
      { label: "Permit (Kerja Ubah Suai Kecil)", value: 335, color: "#327aa8" },
      { label: "Permit Sementara", value: 107, color: "#8a32a8" },
      {
        label: "Permit Sementara (Menara atau Struktur Komunikasi)",
        value: 16,
        color: "#a83295",
      },
      {
        label: "Permit Sementara Bangunan Rumah Pekerja Tapak Bina",
        value: 15,
        color: "#327fa8",
      },
      { label: "Lain-lain", value: 197, color: "#a8325a" },
    ];
    return {
      pieChart: {
        options: {
          chart: {
            height: 365,
            type: "line",
          },
          dataLabels: {
            dropShadow: {
              enabled: false,
              top: 1,
              left: 1,
              blur: 1,
              opacity: 0.45,
            },
          },
          colors: ["#fb5597", "#f59c1a", "#348fe2", "#00acac", "#8753de"],
          labels: ["Team A", "Team B", "Team C", "Team D", "Team E"],
          title: {
            text: "HeatMap Chart (Single color)",
          },
        },
        series: [44, 55, 13, 43, 22],
      },

      donutChart: {
        data: pieChartData,
      },
      barChart: {
        data: barChartData,
        staggerLabels: false,
      },
      configs: {
        timePicker: {
          format: "LT",
          useCurrent: false,
        },
        start: {
          format: "DD/MM/YYYY",
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: new Date(),
          maxDate: false,
        },
        end: {
          format: "DD/MM/YYYY",
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: new Date(),
        },
      },
      columns: [
        {
          label: "KATEGORI",
          field: "KATEGORI",
          thClass: "text-nowrap",
          tdClass: "text-nowrap",
        },
        {
          label: "TEMPOH MINIMA",
          field: "TEMPOHMINIMA",
          width: "15%",
          thClass: "text-nowrap",
          tdClass: "text-nowrap",
        },
        {
          label: "TEMPOH MAKSIMA",
          field: "TEMPOHMAKSIMA",
          type: "number",
          width: "15%",
          tdClass: "text-center text-nowrap",
          thClass: "text-center text-nowrap",
        },
        // {
        //   label: "Created On",
        //   field: "createdAt",
        //   type: "date",
        //   dateInputFormat: "yyyy-mm-dd",
        //   dateOutputFormat: "MMM Do yy",
        //   width: "10%",
        //   tdClass: "text-center text-nowrap",
        //   thClass: "text-center text-nowrap",
        // },
        // {
        //   label: "Percent",
        //   field: "score",
        //   type: "percentage",
        //   width: "10%",
        //   tdClass:
        //     "text-center f-s-14 f-w-600 text-inverse p-t-0 p-b-0 valign-middle text-nowrap",
        //   thClass: "text-center text-nowrap",
        // },
      ],
      rows: [
        {
          id: 1,
          KATEGORI: "Kelulusan Kebenaran Merancang (Kecil)",
          TEMPOHMINIMA: 44,
          TEMPOHMAKSIMA: 86,
        },
        {
          id: 2,
          KATEGORI: "Kelulusan Kebenaran Merancang (Sederhana)",
          TEMPOHMINIMA: 57,
          TEMPOHMAKSIMA: 99,
        },
        {
          id: 3,
          KATEGORI: "Kelulusan Kebenaran Merancang (Besar A)",
          TEMPOHMINIMA: null, // No value provided, so using null
          TEMPOHMAKSIMA: 300,
        },
        {
          id: 4,
          KATEGORI: "Kelulusan Kebenaran Merancang (Besar B)",
          TEMPOHMINIMA: 73,
          TEMPOHMAKSIMA: 115,
        },
        {
          id: 5,
          KATEGORI: "Kelulusan Pelan Bangunan",
          TEMPOHMINIMA: 50,
          TEMPOHMAKSIMA: 92,
        },
        {
          id: 6,
          KATEGORI: "Kelulusan Pelan Jalan Dan Perparitan",
          TEMPOHMINIMA: 50,
          TEMPOHMAKSIMA: 92,
        },
        {
          id: 7,
          KATEGORI: "Kelulusan Pelan Kerja Tanah",
          TEMPOHMINIMA: 50,
          TEMPOHMAKSIMA: 92,
        },
        {
          id: 8,
          KATEGORI: "Kelulusan Pelan Lampu Jalan",
          TEMPOHMINIMA: 33,
          TEMPOHMAKSIMA: 33,
        },
        {
          id: 9,
          KATEGORI: "Kelulusan Pelan Landskap",
          TEMPOHMINIMA: 42,
          TEMPOHMAKSIMA: 86,
        },
        {
          id: 10,
          KATEGORI: "Kelulusan Kebenaran Merancang (Kecil)",
          TEMPOHMINIMA: 44,
          TEMPOHMAKSIMA: 86,
        },
      ],
    };
  },
  computed: {
    ...mapState(useAbdullahStore, ["test", "getTest"]),
  },
  methods: {
    ...mapActions(useAbdullahStore, ["edit"]),

    update() {
      return this.edit("abdullah not awesomeaaaa");
    },
  },
};
</script>
